module.exports = __webpack_public_path__ + "d4377b276cc0b48464e4ac4f2b5a3948.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/loops/loop2.wav
// module id = 87
// module chunks = 0